export default "__VITE_ASSET___I_MLmXS6WUpjwp1BkTZFA__";